/**
 * Prompt model
 */
export class Prompt {
  constructor(data = {}) {
    this.id = data.id || null;
    this.title = data.title || '';
    this.description = data.description || '';
    this.promptText = data.promptText || '';
    this.category = data.category || '';
    // Support multiple categories array (from junction table)
    this.categories = data.categories && Array.isArray(data.categories) ? data.categories : [];
    this.creatorId = data.creatorId || null;
    this.creatorName = data.creatorName || '';
    this.creatorEmail = data.creatorEmail || '';
    this.organizationId = data.organizationId || null;
    this.backgroundTheory = data.backgroundTheory || null;
    // Duplicate prompt properties (for user's duplicated prompts)
    this.userId = data.userId || null;
    this.originalPromptId = data.originalPromptId || null;
    // Ensure numeric values are parsed correctly (SQLite may return strings)
    this.upvotes = typeof data.upvotes === 'number' ? data.upvotes : parseInt(data.upvotes || 0, 10);
    this.downvotes = typeof data.downvotes === 'number' ? data.downvotes : parseInt(data.downvotes || 0, 10);
    this.favoriteCount = typeof data.favoriteCount === 'number' ? data.favoriteCount : parseInt(data.favoriteCount || 0, 10);
    this.createdAt = data.createdAt || new Date().toISOString();
    this.updatedAt = data.updatedAt || new Date().toISOString();
    // User interaction flags (set by API when userId is provided)
    this.hasUpvoted = data.hasUpvoted || false;
    this.hasDownvoted = data.hasDownvoted || false;
    this.isFavorite = data.isFavorite || false;
    // Convert unpaidCopilot to boolean (backend sends as boolean, but handle both)
    this.unpaidCopilot = data.unpaidCopilot === true || data.unpaidCopilot === 1 || data.unpaidCopilot === '1' || data.unpaidCopilot === 'true';
    // Global prompt flag
    this.isGlobal = data.isGlobal === true || data.isGlobal === 1 || data.isGlobal === '1' || data.isGlobal === true;
    // Prompt format: 'FREE_TEXT', 'STRUCTURED', or null
    this.promptFormat = data.promptFormat || null;
    // Free text field
    this.freeText = data.freeText || '';
  }

  /**
   * Create a Prompt instance from data
   */
  static fromData(data) {
    return new Prompt(data);
  }

  /**
   * Convert to plain object
   */
  toJSON() {
    return {
      id: this.id,
      title: this.title,
      description: this.description,
      promptText: this.promptText,
      category: this.category,
      categories: this.categories,
      creatorId: this.creatorId,
      creatorName: this.creatorName,
      creatorEmail: this.creatorEmail,
      organizationId: this.organizationId,
      backgroundTheory: this.backgroundTheory,
      upvotes: this.upvotes,
      downvotes: this.downvotes,
      favoriteCount: this.favoriteCount,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
      unpaidCopilot: this.unpaidCopilot,
      isGlobal: this.isGlobal,
      promptFormat: this.promptFormat,
      freeText: this.freeText,
    };
  }

  /**
   * Get net votes (upvotes - downvotes)
   */
  getNetVotes() {
    return this.upvotes - this.downvotes;
  }
}

